import React from 'react'
import PropTypes from 'prop-types'
import { POPUP_VARIANTS } from '../Sections.const'
import { usePopup } from './Popup.hooks'

const Popup = props => {
	const [{ Element, metaData }] = usePopup(props)

	return Element ? <Element metaData={metaData} /> : null
}

Popup.propTypes = {
	variant: PropTypes.oneOf(Object.values(POPUP_VARIANTS)),
	Element: PropTypes.elementType,
}

export default Popup
